import Map_DynamicMissionGeometry from "@/utils/map/Map_DynamicMissionGeometry";
import Map from "@/utils/Map";

export default class Map_DynamicMission {
  viewer;
  app;
  datasource;
  pickActive;
  pickedInfos;
  dynamicMission;
  timerMouse;
  timerMouseTime;
  lastEventMouseMove;

  constructor(viewer, app) {
    this.viewer = viewer;
    this.app = app;
    this.datasource = undefined;
    this.pickActive = false;
    this.pickedInfos = {
      element: "",
      position: undefined,
      clicRight: false,
      clicLeft: false,
      leftDown : false,
      rightDown:false,
      wheel :0,
      endPosition: undefined,
    };
    this.dynamicMission = undefined;
    this.timerMouse = undefined;
    this.timerMouseTime = 100;
    this.lastEventMouseMove = undefined
    this.init();
  }

  init() {
    this.datasource = new Cesium.CustomDataSource("MapDynamicMission");
    this.viewer.dataSources.add(this.datasource);

    this.dynamicMission = new Map_DynamicMissionGeometry(this.viewer, this.datasource );
    this.initEvents();

  }

  clear() {
    this.dynamicMission.clear();
  }

  enablePick(isEnable) {
    this.pickActive = isEnable;
  }

  dispatchEvent() {

    this.dynamicMission.update(this.pickedInfos);
    this.pickedInfos.clicRight = false;
    this.pickedInfos.clicLeft = false;
  }

  cancel() {

    this.viewer.canvas.style.cursor = "";
    this.pickedInfos.element = "";
    this.pickedInfos.clicRight = false;
    this.pickedInfos.clicLeft = false;
    this.dynamicMission.cancel();

  }


  addMission(coords, speeds, id, name, isKmz) {
    this.dynamicMission.setIsKmz(isKmz);
    this.dynamicMission.setGeom(coords, speeds);
    this.dynamicMission.setName(name);
    this.dynamicMission.setId(id);
  }

  flytoMission() {
    const centroidRectangle = this.dynamicMission.getCentroid();
    Map.flyToRectangle(centroidRectangle);
    /*if(Cesium.defined(centroidRectangle)) {
      this.viewer.camera.flyTo({
        destination: centroidRectangle,
        orientation : {
          heading : Cesium.Math.toRadians(0.0),
          pitch : Cesium.Math.toRadians(-55.0),
          roll : 0.0
        },
      });
    }*/

  }

  updateAltitudeMode(altitudeMode) {
    this.dynamicMission.setAltitudeMode(altitudeMode);
  }

  updateglobalHeight(globalHeight) {
    const value = parseFloat(globalHeight);
    if(!isNaN(value)) {
      this.dynamicMission.setglobalHeight(value);
    }
  }

  updateglobalSpeed(globalSpeed) {
    const value = parseFloat(globalSpeed);
    if(!isNaN(value)) {
      this.dynamicMission.setglobalSpeed(value);
    }
  }

  getGeom() {
    return this.dynamicMission.getGeom();
  }

  getHeightMode() {
    return this.dynamicMission.getAltitudeMode();
  }

  getMissionTime() {
    return this.dynamicMission.getMissionTime();
  }

  getPickedInfos() {
    return this.pickedInfos;
  }

  pickEntiy(position) {
    const pickedObject = this.viewer.scene.pick(position);
    return pickedObject;
  }

  pickPosition(position) {
    this.datasource.show = false;
    //this.viewer.scene.render();
    const cartesian = this.viewer.scene.pickPosition(position);
    this.datasource.show = true;
    return cartesian;
  }

  tryPick(position) {
    let cartesian = this.pickPosition(position);
    if (Cesium.defined(cartesian)) {
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      //// console.log("tryPick "  + cartographic);
      if (cartographic.height < 0) {
        cartesian = undefined;
      }
    }
    if (!Cesium.defined(cartesian)) {
      //// console.log("pickPosition not found");
      cartesian = Map.pickTerrain(position);
    }
    return cartesian;
  }
/*
  pickTerrain(position) {
    const ray = this.viewer.scene.camera.getPickRay(position);
    const cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
    return cartesian;
  }
*/
  setCursor(cursor) {
    this.viewer.canvas.style.cursor = cursor;
  }

  initEvents() {

    this.timerMouse = setInterval(() => {
      if(this.lastEventMouseMove !== undefined){
        this.mouseMove(this.lastEventMouseMove);
        this.lastEventMouseMove = undefined;
      }
    }, this.timerMouseTime);

    let handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas);
    handler.setInputAction((event) => {

      if (this.pickActive) {
        this.lastEventMouseMove = event;
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    handler.setInputAction((event) => {
      if (this.pickActive) {
        this.viewer.selectedEntity = undefined;
        this.pickedInfos.clicRight = true;
        this.dispatchEvent();
      }
    }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);

    handler.setInputAction((event) => {
      if (this.pickActive) {
        this.viewer.selectedEntity = undefined;
        this.pickedInfos.clicLeft = true;
        this.dispatchEvent();

        if($root.global.flightedit.defineTakeoff === true){
          if(Cesium.defined(this.pickedInfos.position)){
            $root.global.flightedit.takeoff_pos=this.pickedInfos.position.latitude + "," +this.pickedInfos.position.longitude + "," + this.pickedInfos.position.height;

            $root.global.flightedit.defineTakeoff = false;
            this.setTakeOffPosition(this.pickedInfos.position);
            // console.log("add takeoff pt",this.pickedInfos);
          }
        }
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    handler.setInputAction((event) => {
      if (this.pickActive) {
        this.viewer.selectedEntity = undefined;
        this.pickedInfos.leftDown = true;
        this.dispatchEvent();
      }
    }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

    handler.setInputAction((event) => {
      if (this.pickActive) {
        this.viewer.selectedEntity = undefined;
        this.pickedInfos.leftDown = false;
        this.dispatchEvent();
      }
    }, Cesium.ScreenSpaceEventType.LEFT_UP);

    handler.setInputAction((wheel) => {
      if (this.pickActive) {
        this.pickedInfos.wheel = wheel > 0 ? 1 : -1;
        this.dispatchEvent();
      }
    }, Cesium.ScreenSpaceEventType.WHEEL);

    handler.setInputAction((event) => {
      if (this.pickActive) {
        this.viewer.selectedEntity = undefined;
        this.pickedInfos.rightDown = true;
        this.dispatchEvent();
      }
    }, Cesium.ScreenSpaceEventType.RIGHT_DOWN);
  }

  mouseMove(event) {

    this.pickedInfos.endPosition = event.endPosition;
    const pickedObject = this.pickEntiy(event.endPosition);

    if($root.global.flightedit.defineTakeoff === true) {
      this.setCursor("copy");
      this.pickedInfos.element = "";
    }
    else if (Cesium.defined(pickedObject) && pickedObject.id) {
        if(pickedObject.id == "frustum") {
          //frustum
          this.pickedInfos.element = pickedObject.id;
        }
        if(pickedObject.id.name && pickedObject.id.name.indexOf("waypointMission") !== -1){
          this.pickedInfos.element = pickedObject.id.name;
        }
    } else {
      this.pickedInfos.element = "";
      this.setCursor("");
    }


    const cartesian = this.tryPick(event.endPosition);
    if (Cesium.defined(cartesian)) {
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian);

      if (Cesium.defined(cartographic) && cartographic.height >= 0) {
        this.pickedInfos.position = new Cesium.Cartographic(
          Cesium.Math.toDegrees(cartographic.longitude),
          Cesium.Math.toDegrees(cartographic.latitude),
          cartographic.height
        );
        //// console.log(cartographic);
        this.dispatchEvent();
      }
    }

  }

  flyToStep(index) {

    const entity = this.dynamicMission.getControlPointEntity(index);
    if(Cesium.defined(entity)) {
      this.viewer.flyTo(entity, {
        duration: 2.0,
        offset: new Cesium.HeadingPitchRange(
          Cesium.Math.toRadians(0),
          Cesium.Math.toRadians(-55),
          400
        ),
      });
    }

  }

  async selectStep(index) {
    if(Number.isInteger(index)) {
      this.dynamicMission.selectStep(index);
    }
  }

  setDronePosition(coord2d) {
    const cartesian2 =  new Cesium.Cartesian2(coord2d.x, coord2d.y);
    if(Cesium.defined(cartesian2)) {
      const cartesian = this.tryPick(cartesian2);
      if(Cesium.defined(cartesian)) {

        const cartographic = Cesium.Cartographic.fromCartesian(cartesian);

        const cartographicdegrees = new Cesium.Cartographic(
          Cesium.Math.toDegrees(cartographic.longitude),
          Cesium.Math.toDegrees(cartographic.latitude),
          cartographic.height + 100
        );
        this.dynamicMission.setDronePosition(cartographicdegrees);
      }
    }

  }

  setAsNoReturn(index, value) {

    if(this.dynamicMission != undefined) {
      this.dynamicMission.setAsNoReturn(index,value == 1 ? true : false);
    }
  }

  async addWaypoint(index, coord2d, yaw, speed) {

    if(coord2d.x == undefined || coord2d.y == undefined) {
      this.dynamicMission.addWaypoint(undefined, index, yaw, speed);
    }
    else{
      const cartesian2 =  new Cesium.Cartesian2(coord2d.x, coord2d.y);
      if(Cesium.defined(cartesian2)) {
        const cartesian = this.tryPick(cartesian2);
        if(Cesium.defined(cartesian)) {
          const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
          if(Cesium.defined(cartographic)) {
            let cartographicdegrees = new Cesium.Cartographic(
              Cesium.Math.toDegrees(cartographic.longitude),
              Cesium.Math.toDegrees(cartographic.latitude),
              this.dynamicMission.getglobalHeight(),
            );
            cartographicdegrees = await this.dynamicMission.convertHeightToGlobal(cartographicdegrees, false);

            this.dynamicMission.addWaypoint(cartographicdegrees, index, yaw, speed);
          }
        }
      }
    }
  }

  updateWaypoint(index) {
    if(Number.isInteger(index)) {
      this.dynamicMission.updateWaypoint(index);
    }
  }

  updateWaypointFollowRoute(index, isFollow) {
    if(Number.isInteger(index)) {
      this.dynamicMission.updateWaypointFollowRoute(index,isFollow);
    }
  }

  removeWaypoint(index) {
    if(Number.isInteger(index)) {
      this.dynamicMission.removeWaypoint(index);
    }
  }

  updateDrone(longitude, latitude, altitude, yaw, speed) {
      if(longitude !== undefined && latitude !== undefined && altitude !== undefined) {
        const cartographic = new Cesium.Cartographic(longitude, latitude,altitude);
        if(Cesium.defined(cartographic)) {
          this.dynamicMission.updateDrone(cartographic, undefined, undefined);
        }
      }
      if(yaw !== undefined ) {
        this.dynamicMission.updateDrone(undefined, yaw, undefined);
      }
      if(speed !== undefined) {
        this.dynamicMission.updateDrone(undefined, undefined, speed);
      }
  }

  getStepDistance(index) {
    if(Number.isInteger(index)) {
      return this.dynamicMission.getStepDistance(index);
    }
  }

  isFollow(index) {
    return this.dynamicMission.isFollow(index);
  }

  getHprHeading(index) {
    return this.dynamicMission.getHprHeading(index);
  }

  updateFrustrum(heading, pitch, zoom) {

    isNaN(parseFloat(heading)) ? heading = undefined : heading = parseFloat(heading);
    isNaN(parseFloat(pitch)) ? pitch = undefined: pitch = parseFloat(pitch);
    isNaN(parseFloat(zoom)) ? zoom = undefined: zoom = parseFloat(zoom);
    if(heading !== undefined || pitch !== undefined || zoom !== undefined) {
      this.dynamicMission.setFrustumOrientationZoom(heading, pitch, zoom);
    }

  }

  updateTakeOff(flyToWaylineMode, takeOffSecurityHeight) {

    const val = parseFloat(takeOffSecurityHeight);
    if(isNaN(val)) {
      return;
    }
    this.dynamicMission.updateTakeOff(flyToWaylineMode,val);

  }

  AddLineRecord(listlinePosColor) {
    if(listlinePosColor != undefined && listlinePosColor.length >0) {
      this.dynamicMission.AddLineRecord(listlinePosColor);
    }
  }

  setMissionAction(infos) {

    $root.global.flightedit.missionActionUpdate = infos;

    const value = parseFloat(infos.value);
    if(isNaN(value)) {
      this.dynamicMission.setFustrumAction(false);
      return;
    }

    if(infos.type == "rotateYaw") {
      this.dynamicMission.updateDrone(undefined, value, undefined);
    }
    if(infos.type == "yaw") {
      this.dynamicMission.setFrustumOrientationZoom(value, undefined, undefined);
    }
    if(infos.type == "pitch") {
      this.dynamicMission.setFrustumOrientationZoom(undefined , value, undefined);
    }
    if(infos.type == "zoom") {
      this.dynamicMission.setFrustumOrientationZoom(undefined, undefined, value);
    }
    if(infos.type == "rotateYaw" || infos.type == "yaw" || infos.type == "pitch" || infos.type == "zoom" || infos.actuatorfunc == "orientedShoot") {
      this.dynamicMission.setFustrumAction(true);
    }
    else{
      this.dynamicMission.setFustrumAction(false);
    }
  }

  setFustrumAction(isAction) {
    if(isAction !== undefined) {
      this.dynamicMission.setFustrumAction(isAction);
    }
  }

  async getWaypointsInfos() {
    return await this.dynamicMission.getWaypointsInfos();
  }

  setTakeOffPosition(cartographic) {
    this.dynamicMission.setTakeOffPosition(cartographic)
    this.dynamicMission.addTakeOff();
  }

  toogle() {
    this.datasource.show = !this.datasource.show;
  }
}
